export default __webpack_public_path__ + "static/media/heartSearch.0669105a.svg";